module.exports = __webpack_public_path__ + "static/kn-c-0d624417342a160d0b35ac449ef3aa4a.jpg";